import { Map, fromJS } from 'immutable';

export function request(state) {
    return state.set(
        'login',
        (state.get('login') || Map())
            .set('state', 'IN_PROGRESS')
            .set('errors', void 0)
    );
}

export function error(state, action) {
    return state.set(
        'login',
        (state.get('login') || Map())
            .set('state', 'ERROR')
            .set('errors', fromJS(action.errors))
    );
}

export function finish(state) {
    return state
        .set('authenticated', true)
        .set(
            'login',
            (state.get('login') || Map())
                .set('state', 'FINISHED')
                .set('errors', void 0)
        );
}

export function clear(state) {
    return state.set('login', Map());
}
